module.exports = __webpack_public_path__ + "img/vanuatu.7e11684.webp";